import { render, staticRenderFns } from "./PasswordSetupView.vue?vue&type=template&id=0b03e9bd&scoped=true"
import script from "./PasswordSetupView.vue?vue&type=script&lang=ts"
export * from "./PasswordSetupView.vue?vue&type=script&lang=ts"
import style0 from "./PasswordSetupView.vue?vue&type=style&index=0&id=0b03e9bd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b03e9bd",
  null
  
)

export default component.exports